import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    standalone: false,
    selector: 'input[alphabetsOnly]'
})
export class OnlyAlphabetDirective {

    constructor(private _el: ElementRef) { }

    key;
    @HostListener('keydown', ['$event']) onKeydown(event: KeyboardEvent) {
        this.key = event.keyCode;
        if (this.key == 46 || this.key == 32 || this.key == 8 || (this.key >= 35 && this.key <= 40) || (this.key >= 65 && this.key <= 90)) {
            return true;
        }
        if ((this.key >= 15 && this.key <= 64) || (this.key >= 123) || (this.key >= 96 && this.key <= 105)) {
            event.preventDefault();
        }
    }

}